import * as ReactService from "@intech/react-service";
import { HeaderInfoRendEntidade } from "../entidades/HeaderInfoRendEntidade";

class InfoRend extends ReactService.BaseService {
  constructor() {
    super("InfoRend");
  }

  BuscarReferencias = () =>
    this.CreateRequest<number[]>(ReactService.RequestType.GET, `BuscarReferencias`);

  BuscarPorReferencia = (referencia: number) =>
    this.CreateRequest<HeaderInfoRendEntidade>(ReactService.RequestType.GET, `BuscarPorReferencia/${referencia}`);

  GerarRelatorio = (referencia: number, enviarPorEmail: boolean) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `GerarRelatorio/${referencia}/${enviarPorEmail}`, null, ReactService.ResponseType.Blob);

}

export const InfoRendService = new InfoRend();
